// extracted by mini-css-extract-plugin
export var phone = "_43-0";